export default {"src":"/_next/static/media/duree.5a07724e.svg","height":541,"width":893};